export const UI_UPDATED = 'UI updated ✨';
export const LANGUAGE_UPDATED = 'Language updated 🌐';
